// eslint-disable-next-line simple-import-sort/imports -- this must be imported first
import { initWdyr } from './dev/wdyr';

import './bootstrap/publicPath';

import { createRoot } from 'react-dom/client';

import { oneObject } from '#/bootstrap/oneObject';
import { devtoolsApi } from '#/dev/devtools';
import { initConfig } from '#/hooks/useConfig';
import { ensureCorrectSearchParams, ignoreError } from '#/service/utils';

import { AppRouter } from './App';
import { GlobalStyle } from './components/GlobalStyle';
import { translationActions } from './store/translation/translation.store';
import { ThemeProvider } from 'styled-components';
import { bootActions } from '#/store/boot/boot.store';
import { initSentry } from './bootstrap/initSentry';
import { initEventBatchManager } from './bootstrap/initEventBatchManager';

ensureCorrectSearchParams();

const config = oneObject.config;

initConfig(config);
initSentry(config);
initEventBatchManager(config);

if (process.env.goal === 'local') {
  devtoolsApi.overrideConsole();
  devtoolsApi.setWdyr(initWdyr);
}

translationActions.load(config.i18nextConfig).catch(ignoreError);
bootActions.startBootstrap(config);

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <ThemeProvider theme={config.theme}>
    <GlobalStyle />
    <AppRouter />
  </ThemeProvider>
);
